module.exports = __webpack_public_path__ + "img/arbre_1.7b36ba33.png";